// extracted by mini-css-extract-plugin
export var columnList = "_d7-0";